import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const FastForwardIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('FastForwardIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M13,20c-0.15,0-0.3-0.03-0.44-0.1C12.22,19.73,12,19.38,12,19V5c0-0.38,0.22-0.73,0.56-0.9c0.34-0.17,0.75-0.13,1.05,0.11
	l9,7C22.86,11.4,23,11.69,23,12s-0.14,0.6-0.39,0.79l-9,7C13.43,19.93,13.22,20,13,20z M14,7.04v9.91L20.37,12L14,7.04z"
    />
    <path
      d="M2,20c-0.15,0-0.3-0.03-0.44-0.1C1.22,19.73,1,19.38,1,19V5c0-0.38,0.22-0.73,0.56-0.9C1.9,3.93,2.31,3.98,2.61,4.21l9,7
	C11.86,11.4,12,11.69,12,12s-0.14,0.6-0.39,0.79l-9,7C2.44,19.93,2.22,20,2,20z M3,7.04v9.91L9.37,12L3,7.04z"
    />
  </svg>
);

export default FastForwardIcon;
